import * as actionTypes from '../actions/actionTypes';
import { updateObject } from './../../../../shared/utils';

const initialState = {
  phonebookContacts: null,
  error: null,
  phonebookContactsLoading: false,
};

const getContactsByTypeStart = (state, action) => {
  return updateObject(state, {
    phonebookContacts: null,
    error: null,
    phonebookContactsLoading: true,
  });
};

const getContactsByTypeSuccess = (state, action) => {
  return updateObject(state, {
    phonebookContacts: action.phonebookContacts,
    error: null,
    phonebookContactsLoading: false,
  });
};

const getContactsByTypeFail = (state, action) => {
  return updateObject(state, {
    phonebookContacts: null,
    error: action.error,
    phonebookContactsLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CONTACTS_BY_TYPE:
      return getContactsByTypeStart(state, action);
    case actionTypes.GET_CONTACTS_BY_TYPE_SUCCESS:
      return getContactsByTypeSuccess(state, action);
    case actionTypes.GET_CONTACTS_BY_TYPE_FAIL:
      return getContactsByTypeFail(state, action);

    default:
      return state;
  }
};

export default reducer;
